module.exports = __webpack_public_path__ + "img/35.e2c60975.jpg";